import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import {
  Button,
  Card,
  Group,
  Title,
  Divider,
  Space,
  Text,
  List,
  Flex,
  ThemeIcon,
} from "@mantine/core";
import { IconCheck, IconX, IconBell } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export default function CampaignStatus({
  campaignId,
  fetchData,
  status = 1,
  liveStatus = {},
  hasChangesToPublish = false,
  isLive = false,
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onClick(newStatus) {
    const req = {
      campaign_id: campaignId,
      status: newStatus,
    };

    setLoading(true);

    axios
      .put(`/campaigns/${campaignId}/set-status/`, req)
      .then(() => {
        setLoading(false);
        toast.success(t("common:saved") + "!");
        fetchData();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const items = [
    { text: t("common:active"), value: liveStatus.active },
    { text: t("common:live"), value: liveStatus.is_live },
    { text: t("common:turned_on"), value: liveStatus.turned_on },
    // {
    //   text: "published configuration",
    //   value: liveStatus.published_configuration,
    // },
  ];

  const btns = [
    // { text: "created", value: 1, color: "yellow" },
    { text: t("common:on"), value: 2, color: "green" },
    { text: t("common:off"), value: 3, color: "red" },
    { text: t("common:deleted"), value: 4, color: "yellow" },
  ].map((m) => ({
    ...m,
    key: m.value,
  }));

  return (
    <Card>
      <SectionDivider text={t("mixer:campaign:campaign_checkup")} />
      <div>
        {items.map((item, i) => (
          <Flex key={i} align="center" gap="xs" mb="xs">
            <ThemeIcon
              variant="filled"
              radius="xl"
              size="sm"
              color={item.value ? "green" : "red"}
            >
              {item.value ? <IconCheck /> : <IconX />}{" "}
            </ThemeIcon>
            <Text>{item.text}</Text>
          </Flex>
        ))}
      </div>
      <SectionDivider text={t("common:status")} />
      <Group spacing="xs">
        {btns.map((b) => (
          <Button
            key={b.key}
            onClick={() => onClick(b.value)}
            color={b.color}
            size="xs"
            variant={status === b.value ? "filled" : "light"}
          >
            {b.text}
          </Button>
        ))}
      </Group>
      <SectionDivider text={t("common:publish")} />
      <PublishButton campaignId={campaignId} onSuccess={fetchData} />
      {hasChangesToPublish && (
        <Text
          style={{ display: "flex", alignItems: "center" }}
          mt="xs"
          size="xs"
        >
          <ThemeIcon
            // variant="filled"
            variant="light"
            radius="xl"
            mr="xs"
            size="sm"
            color="pink.4"
          >
            <IconBell />
          </ThemeIcon>{" "}
          {t("common:unpublished_changes")}
        </Text>
      )}
    </Card>
  );
}

const PublishButton = ({ campaignId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onClick() {
    setLoading(true);
    axios
      .put(`/campaigns/${campaignId}/publish-app-config/`, {})
      .then(() => {
        setLoading(false);
        toast.success(t("common:published") + "!");
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <Button loading={loading} onClick={onClick} size="xs" color="green">
      {t("mixer:campaign:publish_campaign")}
    </Button>
  );
};

const SectionDivider = ({ text }) => <Divider my="sm" label={text} />;
